import { useState } from "react";
import {
  DEFAULT_PATIENT_CLAIMS_FILTERS,
  PatientClaimsFilterData,
} from "./financial-filters-context";
import useActiveComponentCountController from "../../../../../../../components/filter/use-ActiveComponentCountController";
import GlobalFilter from "../../../../../../../components/GlobalFilter";
import Flex from "../../../../../../../components/Flex";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
} from "@mui/material";
import Text from "../../../../../../../components/Text";
import MaskMultiSelect from "../../../../../../../components/MaskMultiSelect";
import { CLAIMS_STATUS_LIST } from "../../../../billings/claims/claims-constants";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
type Option = { value: string; label: string };

const CLAIM_TYPE_LIST: Option[] = [
  { value: "electronic_claim", label: "Electronic Claim" },
  { value: "paper_claim", label: "Paper Claim" },
];

export const PatientClaimsFilters = ({
  filters,
  setFilters,
}: {
  filters: PatientClaimsFilterData;
  setFilters: (v: PatientClaimsFilterData) => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [draft, setDraft] = useState<PatientClaimsFilterData>(filters);
  const [expanded, setExpanded] = useState<string | false>("claim_statuses");

  const activeFilterCount = useActiveComponentCountController(filters);

  const handleExpand = (key: string) => (_: unknown, isExpanded: boolean) =>
    setExpanded(isExpanded ? key : false);

  const closeFilter = () => setAnchorEl(null);

  const handleApply = () => {
    setFilters(draft);
    closeFilter();
  };

  const handleClear = () => {
    setDraft(DEFAULT_PATIENT_CLAIMS_FILTERS);
    setFilters(DEFAULT_PATIENT_CLAIMS_FILTERS);
  };

  const handleCancel = () => {
    setDraft(filters);
    closeFilter();
  };

  return (
    <GlobalFilter
      anchorEl={anchorEl}
      setAnchorEl={setAnchorEl}
      activeFilterCount={activeFilterCount}
    >
      <Flex
        width={"18.438rem"}
        flexDirection={"column"}
        justifyContent={"space-between"}
      >
        <Box>
          <Flex width={"100%"} justifyContent={"end"}>
            <Button variant="text" onClick={handleClear}>
              Clear Filter
            </Button>
          </Flex>

          <Accordion
            variant="outlined"
            expanded={expanded === "claim_statuses"}
            onChange={handleExpand("claim_statuses")}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Text>Claim Status</Text>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: 1 }}>
              <MaskMultiSelect
                optionWithCheckbox={true}
                value={draft.claim_statuses}
                placeholder="Claim Status"
                options={CLAIMS_STATUS_LIST}
                onChange={(val) =>
                  setDraft((prev) => ({ ...prev, claim_statuses: val }))
                }
              />
            </AccordionDetails>
          </Accordion>

          <Accordion
            variant="outlined"
            expanded={expanded === "claim_types"}
            onChange={handleExpand("claim_types")}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Text>Claim Type</Text>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: 1 }}>
              <MaskMultiSelect
                optionWithCheckbox={true}
                value={draft.claim_types}
                placeholder="Claim Type"
                options={CLAIM_TYPE_LIST}
                onChange={(val) =>
                  setDraft((prev) => ({ ...prev, claim_types: val }))
                }
              />
            </AccordionDetails>
          </Accordion>
        </Box>

        <Flex width={"100%"} justifyContent={"end"}>
          <Button variant="text" sx={{ color: "gray" }} onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="text" onClick={handleApply}>
            Apply
          </Button>
        </Flex>
      </Flex>
    </GlobalFilter>
  );
};
